import {
  Box,
  Typography,
  Select,
  MenuItem,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
  Switch,
  Checkbox,
  FormControlLabel,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Tooltip,
  alpha,
} from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { useState, useEffect } from "react";
import EditIcon from "@mui/icons-material/Edit";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import DeleteIcon from "@mui/icons-material/Delete";
import FilterListIcon from "@mui/icons-material/FilterList";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import ListAltIcon from "@mui/icons-material/ListAlt";
import InboxOutlinedIcon from "@mui/icons-material/InboxOutlined";

import dayjs from "dayjs";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import LinkIcon from "@mui/icons-material/Link";
import axios from "axios";
import { P2PWEBSERVICE, showToast, WEBSERVICE } from "../../CoreDataService";
import { useForm } from "react-hook-form";

import CloseIcon from "@mui/icons-material/Close";
import { useNavigate } from "react-router-dom";
import P2PNavbar from "./P2PNavbar";
import { useSelector } from "react-redux";
import { ContainedButton, OutlinedButton } from "../../Common/Buttons";

export default function P2PMyAdsPage() {
  const navigate = useNavigate();
  const { btncolor } = useSelector((state) => state);
  const themeColor = localStorage.getItem("theme");

  const [filters, setFilters] = useState({
    asset: "",
    type: "",
    status: "",
    fromDate: null,
    toDate: null,
  });

  const [selectedRows, setSelectedRows] = useState([]);
  const [selectAllChecked, setSelectAllChecked] = useState(false);
  const [selectedAds, setSelectedAds] = useState([]);
  const [adsDetailsList, setAdsDetailsList] = useState([]);
  const [adsListCount, setAdsListCount] = useState(0);
  const [loading, setLoading] = useState(false);
  const [statusSelected, setStatusSelected] = useState(2);
  const [asset, setAsset] = useState("");
  const [adType, setAdType] = useState("");
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [deleteIndex, setDeleteIndex] = useState("");
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [editAds, setEditAds] = useState([]);
  const [updateIndex, setUpdateIndex] = useState("");
  const [editAdModalOpen, setEditAdModalOpen] = useState(false);
  const [regionList, setRegionList] = useState([]);
  const [allCurrencies, setAllCurrencies] = useState([]);
  const [selectedFiatCurrency, setSelectedFiatCurrency] = useState("USDT");
  const [coin, setCoin] = useState("");

  const {
    register,
    handleSubmit,
    formState: { errors, isDirty },
    reset,
    watch,
  } = useForm();

  const formatDate = (date) => {
    if (!date) return "";
    const year = date.year();
    let month = (date.month() + 1).toString().padStart(2, "0");
    let day = date.date().toString().padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const handleChange = (key, value) => {
    setFilters({ ...filters, [key]: value });
  };

  const handleSelectRow = (i) => {
    const ad = adsDetailsList[i];
    const adId = ad.adId;

    const isAlreadySelected = selectedRows.includes(adId);
    let updatedSelectedRows, updatedSelectedAds;

    if (isAlreadySelected) {
      updatedSelectedRows = selectedRows.filter((id) => id !== adId);
      updatedSelectedAds = selectedAds.filter((item) => item.adId !== adId);
    } else {
      updatedSelectedRows = [...selectedRows, adId];
      updatedSelectedAds = [...selectedAds, ad];
    }

    setSelectedRows(updatedSelectedRows);
    setSelectedAds(updatedSelectedAds);

    // Update selectAll checkbox
    setSelectAllChecked(updatedSelectedRows.length === adsDetailsList.length);
  };

  const handleSelectAll = (checked) => {
    setSelectAllChecked(checked);

    if (checked) {
      const allIds = adsDetailsList.map((ad) => ad.adId);
      setSelectedRows(allIds);
      setSelectedAds([...adsDetailsList]);
    } else {
      setSelectedRows([]);
      setSelectedAds([]);
    }
  };

  const getAllCountryRegion = () => {
    setLoading(true); // Set loading to true while fetching data

    const token = localStorage.getItem("access_token");
    const headers = {
      "Content-Type": "application/json",
      Authorization: `BEARER ${token}`,
    };

    axios
      .get(P2PWEBSERVICE + "/getAllRegions", { headers })
      .then((response) => {
        setLoading(false); // Set loading to false once the data is fetched
        const apiMessage = response.data.error.error_data;

        if (apiMessage === 0) {
          setRegionList(response.data.regions); // Update state with regions
        }
      })
      .catch((error) => {
        setLoading(false); // Set loading to false on error
        console.error("Error fetching regions:", error);
      });
  };

  const isRowSelected = (adId) => selectedRows.includes(adId);

  // Dummy data for demonstration
  useEffect(() => {
    getCurrencyByAd();
    getAllOpenAdsByUser();
    getAllCountryRegion();
  }, []);

  const getCurrencyByAd = async () => {
    try {
      const response = await axios.get(
        `${WEBSERVICE}crypto/banking/p2p/getCurrencyByAd/${localStorage.getItem(
          "BROKERID"
        )}`,
        {
          headers: {
            "Content-Type": "application/json",
            authorization: "BEARER " + localStorage.getItem("access_token"),
          },
        }
      );

      const assetDetails = response.data.assetDetails || [];

      setAllCurrencies(assetDetails);
      setSelectedFiatCurrency(assetDetails[0]?.currencyCode || "");
    } catch (error) {
      console.error("Error fetching currency data:", error);
    }
  };

  const resetAll = async () => {
    setStatusSelected("");
    setFromDate(null);
    setToDate(null);
    setCoin("");
    setAdType("");
    resetAllOpenAdsByUser();
  };

  const resetAllOpenAdsByUser = async () => {
    setLoading(true);
    const jsonObj = {
      uuid: localStorage.getItem("uuid"),
      crypto: "",
      adType: "",
      fromDate: formatDate(fromDate),
      toDate: formatDate(toDate),
      status: 2,
    };

    try {
      const response = await axios.post(
        `${P2PWEBSERVICE}/getAllOpenAdsByUser`,
        JSON.stringify(jsonObj),
        {
          headers: {
            "Content-Type": "application/json",
            authorization: "BEARER " + localStorage.getItem("access_token"),
          },
        }
      );

      const { error, p2pMyAdResponse, paymentMethod } = response.data;

      if (error.error_data === 0) {
        if (!p2pMyAdResponse || p2pMyAdResponse.length === 0) {
          setAdsDetailsList([]);
          return;
        }

        const processedAds = p2pMyAdResponse.map((ad) => {
          const statusText =
            ad.onlineOfflineStatus === 0 ? "Offline" : "Published";
          const paymentDetails = paymentMethod.filter(
            (p) => p.adId === ad.adId
          );

          let paymentMethodNameDisplay = "No Payment Method Details Found";
          if (paymentDetails.length > 0) {
            paymentMethodNameDisplay = paymentDetails
              .map((p) => p.paymentProviderName)
              .join(", ");
          }

          return {
            ...ad,
            status: statusText,
            paymentMethodNameDisplay,
            ...(paymentDetails[0] || {}),
          };
        });

        setAdsDetailsList(processedAds);
        setAdsListCount(processedAds.length);

        console.log("processedAds", processedAds);
      } else {
        alert(error.error_msg);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const getAllOpenAdsByUser = async () => {
    setLoading(true);
    const jsonObj = {
      uuid: localStorage.getItem("uuid"),
      crypto: coin,
      adType: adType,
      fromDate: formatDate(fromDate),
      toDate: formatDate(toDate),
      status: statusSelected ? statusSelected : 2,
    };

    try {
      const response = await axios.post(
        `${P2PWEBSERVICE}/getAllOpenAdsByUser`,
        JSON.stringify(jsonObj),
        {
          headers: {
            "Content-Type": "application/json",
            authorization: "BEARER " + localStorage.getItem("access_token"),
          },
        }
      );

      const { error, p2pMyAdResponse, paymentMethod } = response.data;

      if (error.error_data === 0) {
        if (!p2pMyAdResponse || p2pMyAdResponse.length === 0) {
          setAdsDetailsList([]);
          return;
        }

        const processedAds = p2pMyAdResponse.map((ad) => {
          const statusText =
            ad.onlineOfflineStatus === 0 ? "Offline" : "Published";
          const paymentDetails = paymentMethod.filter(
            (p) => p.adId === ad.adId
          );

          let paymentMethodNameDisplay = "No Payment Method Details Found";
          if (paymentDetails.length > 0) {
            paymentMethodNameDisplay = paymentDetails
              .map((p) => p.paymentProviderName)
              .join(", ");
          }

          return {
            ...ad,
            status: statusText,
            paymentMethodNameDisplay,
            ...(paymentDetails[0] || {}),
          };
        });

        setAdsDetailsList(processedAds);
        setAdsListCount(processedAds.length);

        console.log("processedAds", processedAds);
      } else {
        alert(error.error_msg);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const activateDeactivateAll = (status) => {
    if (selectedAds.length === 0) {
      showToast("error", "No ads are selected"); // Use your toast/snackbar handler
      return;
    }

    setLoading(true);

    if (status === 1) {
      allOnlineOffline(0, 1);
    } else {
      allOnlineOffline(0, 0);
    }
  };

  const allOnlineOffline = (j, onlineOfflineStatus) => {
    const ad = selectedAds[j];

    const bankName =
      ad.paymentMethodName === "BANK TRANSFER" ? ad.paymentProviderName : "";

    const paymentObj = {
      action: "UPDATE",
      pmDetailsId: 0,
      uuid: localStorage.getItem("uuid"),
      paymentMethodName: "",
      profileName: "",
      vpa: "",
      bankName: "",
      accountNo: "",
      ifscCode: "",
      swiftCode: "",
      routingNo: "",
    };

    const jsonObj = {
      isActive: 1,
      adId: ad.adId,
      priceType: ad.priceType,
      price: ad.price.toString(),
      amount: ad.amount,
      paymentTimeLimit: ad.paymentTimeLimit,
      maxOrderLimit: ad.maxOrderLimit,
      minOrderLimit: ad.minOrderLimit,
      remarks: ad.remarks,
      autoReply: ad.autoReply,
      region: ad.region,
      registeredDays: ad.registeredDays,
      totalHoldings: ad.totalHoldings,
      onlineOfflineStatus: onlineOfflineStatus,
      paymentDetails: paymentObj,
    };

    axios
      .post(`${P2PWEBSERVICE}/updateBuySellAd`, jsonObj, {
        headers: {
          "Content-Type": "application/json",
          authorization: `BEARER ${localStorage.getItem("access_token")}`,
        },
      })
      .then((res) => {
        const apiMessage = res.data?.error?.error_data;
        if (apiMessage === 0) {
          const nextIndex = j + 1;
          if (nextIndex < selectedAds.length) {
            allOnlineOffline(nextIndex, onlineOfflineStatus);
          } else {
            setLoading(false);
            showToast(
              "success",
              onlineOfflineStatus === 0
                ? "All ads made offline"
                : "All ads made Published"
            );
            setTimeout(() => {
              window.location.reload();
            }, 2000);
          }
        }
      })
      .catch((err) => {
        setLoading(false);
        showToast("error", "Error updating ads");
      });
  };

  const tooltipOperations = (operationType, j) => {
    let action = "";
    let successMsg = "";
    let onlineOfflineStatus;

    switch (operationType) {
      case "duplicate":
        action = "DUPLICATE";
        successMsg = "Ad duplicated successfully";
        runApi(action, successMsg, j);
        break;

      case "delete":
        setDeleteIndex(j);
        setDeleteModalOpen(true);
        break;

      case "online":
        successMsg = "Ad Published Successfully";
        onlineOfflineStatus = 1;
        runApiForOnlineOffline(successMsg, j, onlineOfflineStatus);
        break;

      case "offline":
        successMsg = "Ad Made Offline Successfully";
        onlineOfflineStatus = 0;
        runApiForOnlineOffline(successMsg, j, onlineOfflineStatus);
        break;

      case "edit":
        const ad = adsDetailsList[j];

        setEditAds([ad]);
        reset({
          priceType: ad?.priceType || "Fixed",
          price: ad?.price || "",
          amount: ad?.amount || "",
          paymentTimeLimit: ad?.paymentTimeLimit || "",
          maxOrderLimit: ad?.maxOrderLimit || "",
          minOrderLimit: ad?.minOrderLimit || "",
          remarks: ad?.remarks || "",
          autoReply: ad?.autoReply || "",
          region: ad?.region || "",
          registeredDays: ad?.registeredDays || "",
          totalHoldings: ad?.totalHoldings || "",
        });
        setUpdateIndex(j);
        setEditAdModalOpen(true);
        break;

      default:
        break;
    }
  };

  const runApi = async (action, successMsg, j) => {
    setLoading(true);
    const ad = adsDetailsList[j];
    const isActive = action === "DELETE" ? 0 : 1;

    const paymentObj = {
      action,
      pmDetailsId: 0,
      uuid: localStorage.getItem("uuid"),
      paymentMethodName: "",
      profileName: "",
      vpa: "",
      bankName: "",
      accountNo: "",
      ifscCode: "",
      swiftCode: "",
      routingNo: "",
    };

    const jsonObj = {
      isActive,
      adId: ad.adId,
      priceType: ad.priceType,
      price: ad.price.toString(),
      amount: ad.amount,
      paymentTimeLimit: ad.paymentTimeLimit,
      maxOrderLimit: ad.maxOrderLimit,
      minOrderLimit: ad.minOrderLimit,
      remarks: ad.remarks,
      autoReply: ad.autoReply,
      region: ad.region,
      registeredDays: ad.registeredDays,
      totalHoldings: ad.totalHoldings,
      onlineOfflineStatus: ad.onlineOfflineStatus,
      paymentDetails: paymentObj,
    };

    try {
      const res = await axios.post(
        `${P2PWEBSERVICE}/updateBuySellAd`,
        JSON.stringify(jsonObj),
        {
          headers: {
            "Content-Type": "application/json",
            authorization: `BEARER ${localStorage.getItem("access_token")}`,
          },
        }
      );

      const { error } = res.data;
      if (error.error_data === 0) {
        showToast("success", successMsg);
        setDeleteModalOpen(false);
        setTimeout(() => {
          getAllOpenAdsByUser();
        }, 2000);
      } else {
        showToast("error", error.error_msg);
      }
    } catch (err) {
      showToast("error", "Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  const runApiForOnlineOffline = async (successMsg, j, onlineOfflineStatus) => {
    setLoading(true);
    const ad = adsDetailsList[j];

    const paymentObj = {
      action: "UPDATE",
      pmDetailsId: 0,
      uuid: localStorage.getItem("uuid"),
      paymentMethodName: "",
      profileName: "",
      vpa: "",
      bankName: "",
      accountNo: "",
      ifscCode: "",
      swiftCode: "",
      routingNo: "",
    };

    const jsonObj = {
      isActive: 1,
      adId: ad.adId,
      priceType: ad.priceType,
      price: ad.price.toString(),
      amount: ad.amount,
      paymentTimeLimit: ad.paymentTimeLimit,
      maxOrderLimit: ad.maxOrderLimit,
      minOrderLimit: ad.minOrderLimit,
      remarks: ad.remarks,
      autoReply: ad.autoReply,
      region: ad.region,
      registeredDays: ad.registeredDays,
      totalHoldings: ad.totalHoldings,
      onlineOfflineStatus,
      paymentDetails: paymentObj,
    };

    try {
      const res = await axios.post(
        `${P2PWEBSERVICE}/updateBuySellAd`,
        JSON.stringify(jsonObj),
        {
          headers: {
            "Content-Type": "application/json",
            authorization: `BEARER ${localStorage.getItem("access_token")}`,
          },
        }
      );

      const { error } = res.data;
      if (error.error_data === 0) {
        showToast("success", successMsg);
        setTimeout(() => {
          getAllOpenAdsByUser();
        }, 2000);
      } else {
        showToast("error", error.error_msg);
      }
    } catch (err) {
      showToast("error", "Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  const updateAds = async (action, successMsg) => {
    const ad = editAds[0];

    if (
      ad.price === 0 ||
      ad.amount === 0 ||
      ad.maxOrderLimit === 0 ||
      ad.minOrderLimit === 0
    ) {
      return showToast("error", "Price, Amount, and Order Limits can't be 0");
    }
    if (ad.minOrderLimit > ad.maxOrderLimit) {
      return showToast(
        "error",
        "Min order Limit can't be greater than Max Order Limit"
      );
    }
    if (ad.region === "") {
      return showToast("error", "Region Availability can't be empty");
    }
    if (ad.registeredDays === 0) {
      return showToast("error", "Registered days can't be 0");
    }
    if (ad.totalHoldings < 1) {
      return showToast(
        "error",
        "Total holdings can't be lesser than 1, please increase it"
      );
    }

    setLoading(true);

    const paymentObj = {
      action,
      pmDetailsId: 0,
      uuid: localStorage.getItem("uuid"),
      paymentMethodName: "",
      profileName: "",
      vpa: "",
      bankName: "",
      accountNo: "",
      ifscCode: "",
      swiftCode: "",
      routingNo: "",
    };

    const jsonObj = {
      isActive: 1,
      adId: ad.adId,
      priceType: ad.priceType,
      price: ad.price.toString(),
      amount: ad.amount,
      paymentTimeLimit: ad.paymentTimeLimit,
      maxOrderLimit: ad.maxOrderLimit,
      minOrderLimit: ad.minOrderLimit,
      remarks: ad.remarks,
      autoReply: ad.autoReply,
      region: ad.region,
      registeredDays: ad.registeredDays,
      totalHoldings: ad.totalHoldings,
      onlineOfflineStatus: ad.onlineOfflineStatus,
      paymentDetails: paymentObj,
    };

    try {
      const res = await axios.post(
        `${P2PWEBSERVICE}/updateBuySellAd`,
        JSON.stringify(jsonObj),
        {
          headers: {
            "Content-Type": "application/json",
            authorization: `BEARER ${localStorage.getItem("access_token")}`,
          },
        }
      );

      const { error } = res.data;
      if (error.error_data === 0) {
        showToast("success", successMsg);
        setEditAds([]);
        setEditAdModalOpen(false);
        setTimeout(() => {
          getAllOpenAdsByUser();
        }, 2000);
      } else {
        showToast("error", error.error_msg);
      }
    } catch (err) {
      showToast("error", "Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  const handleOnLineOfflineAds = async (e, j) => {
    if (e == true) {
      tooltipOperations("online", j);
    } else {
      tooltipOperations("offline", j);
    }
  };

  const handleRedirectOrderByAdsPage = async (data) => {
    navigate("/p2p/orders-by-ad/" + data.adId);
  };

  const handleUpdate = (data) => {
    // onUpdateAd(data);
    // onCloseEdit();
    console.log("edit data", adsDetailsList[0]);

    if (parseFloat(data.price) == 0) {
      showToast("error", "Price can't be 0");
      return;
    }

    if (parseFloat(data.amount) == 0) {
      showToast("error", "Amount can't be 0");
      return;
    }

    if (parseFloat(data.maxOrderLimit) == 0) {
      showToast("error", "Max order Limit can't be 0");
      return;
    }

    if (parseFloat(data.minOrderLimit) == 0) {
      showToast("error", "Min order Limit can't be 0");
      return;
    }

    if (parseFloat(data.minOrderLimit) > parseFloat(data.maxOrderLimit)) {
      showToast(
        "error",
        "Min order Limit can't be greater than Max Order Limit"
      );
      return;
    }

    if (parseFloat(data.minOrderLimit) > parseFloat(data.maxOrderLimit)) {
      showToast(
        "error",
        "Min order Limit can't be greater than Max Order Limit"
      );
      return;
    }

    if (data.region == "") {
      showToast("error", "Region Availability can't be empty");
      return;
    }

    if (parseFloat(data.registeredDays) == 0) {
      showToast("error", "Registered days can't be 0");
      return;
    }

    if (parseFloat(data.totalHoldings) < 1) {
      showToast(
        "error",
        "Total holdings can't be lesser than 1,please increase it"
      );
      return;
    }

    const ad = data;

    const bankName =
      ad.paymentMethodName === "BANK TRANSFER" ? ad.paymentProviderName : "";

    const paymentObj = {
      action: "UPDATE",
      pmDetailsId: 0,
      uuid: localStorage.getItem("uuid"),
      paymentMethodName: "",
      profileName: "",
      vpa: "",
      bankName: "",
      accountNo: "",
      ifscCode: "",
      swiftCode: "",
      routingNo: "",
    };

    const jsonObj = {
      isActive: 1,
      adId: adsDetailsList[0].adId,
      priceType: ad.priceType,
      price: ad.price.toString(),
      amount: ad.amount,
      paymentTimeLimit: ad.paymentTimeLimit,
      maxOrderLimit: ad.maxOrderLimit,
      minOrderLimit: ad.minOrderLimit,
      remarks: ad.remarks,
      autoReply: ad.autoReply,
      region: ad.region,
      registeredDays: ad.registeredDays,
      totalHoldings: ad.totalHoldings,
      onlineOfflineStatus: adsDetailsList[0].onlineOfflineStatus,
      paymentDetails: paymentObj,
    };

    console.log("jsonObj", jsonObj);

    axios
      .post(`${P2PWEBSERVICE}/updateBuySellAd`, jsonObj, {
        headers: {
          "Content-Type": "application/json",
          authorization: `BEARER ${localStorage.getItem("access_token")}`,
        },
      })
      .then((res) => {
        const apiMessage = res.data?.error?.error_data;
        if (apiMessage === 0) {
          showToast("success", "Ad data updated");
          setEditAdModalOpen(false);
          setTimeout(() => {
            window.location.reload();
          }, 1500);
        } else {
          showToast("error", res.data?.error?.error_msg);
        }
      })
      .catch((err) => {
        setLoading(false);
        showToast("error", "Error updating ads");
      });
  };

  // ── Style constants ──────────────────────────────────────────────────────────

  const pageWrapper = {
    px: { xs: 2, md: 4 },
    py: { xs: 2, md: 3 },
    backgroundColor: "var(--body-color)",
    color: "var(--text-color)",
    minHeight: "calc(100vh - 64px)",
  };

  const heroBanner = {
    borderRadius: "18px",
    p: { xs: 2.5, md: 3.5 },
    mb: 3,
    display: "flex",
    alignItems: "center",
  };

  const heroIconBadge = {
    width: 56,
    height: 56,
    borderRadius: "14px",
    backgroundColor: "rgba(255,255,255,0.18)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    mr: 2.5,
    flexShrink: 0,
  };

  const heroTitle = {
    fontSize: { xs: "1.25rem", md: "1.5rem" },
    fontWeight: 700,
    color: "#fff",
    lineHeight: 1.2,
    mb: 0.5,
  };

  const heroSubtitle = {
    fontSize: { xs: "0.82rem", md: "0.9rem" },
    color: "rgba(255,255,255,0.88)",
    lineHeight: 1.5,
  };

  const mainCard = {
    backgroundColor: "var(--body-color-less)",
    borderRadius: "16px",
    border: "1px solid rgba(125,125,125,0.15)",
    boxShadow: "0 1px 3px rgba(0,0,0,0.06)",
    overflow: "hidden",
    mb: 3,
  };

  const filterCard = {
    p: { xs: 2, md: 2.5 },
    mb: 3,
    backgroundColor: "var(--body-color-less2)",
    borderRadius: "12px",
    border: "1px solid rgba(125,125,125,0.12)",
  };

  const filterGrid = {
    display: "grid",
    gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr", md: "repeat(5, 1fr) auto" },
    gap: 1.5,
    alignItems: "end",
  };

  const fieldWrap = {
    display: "flex",
    flexDirection: "column",
    gap: 0.75,
  };

  const fieldLabel = {
    fontSize: "0.78rem",
    fontWeight: 600,
    color: "var(--text-color)",
    opacity: 0.6,
    textTransform: "uppercase",
    letterSpacing: "0.04em",
  };

  const modernFieldStyle = {
    "& .MuiOutlinedInput-root": {
      backgroundColor: "var(--body-color-less)",
      borderRadius: "8px",
      "& fieldset": { borderColor: "rgba(125,125,125,0.2)" },
      "&:hover fieldset": { borderColor: "rgba(125,125,125,0.4)" },
      "&.Mui-focused fieldset": { borderColor: btncolor },
    },
    "& .MuiInputBase-input": { color: "var(--text-color)", fontSize: "0.88rem" },
    "& .MuiInputLabel-root": { display: "none" },
    "& .MuiSelect-icon": { color: "var(--text-color)" },
  };

  const filterBtn = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: 0.5,
    px: 2,
    py: 1,
    borderRadius: "8px",
    cursor: "pointer",
    fontSize: "0.82rem",
    fontWeight: 600,
    backgroundColor: alpha(btncolor || "#1976d2", 0.12),
    color: btncolor || "#1976d2",
    border: `1px solid ${alpha(btncolor || "#1976d2", 0.25)}`,
    "&:hover": { backgroundColor: alpha(btncolor || "#1976d2", 0.2) },
    userSelect: "none",
  };

  const bulkActionsBar = {
    display: "flex",
    alignItems: "center",
    gap: 2,
    mb: 2.5,
    p: 1.5,
    backgroundColor: "var(--body-color-less2)",
    borderRadius: "10px",
    border: "1px solid rgba(125,125,125,0.12)",
    flexWrap: "wrap",
  };

  const modernTableContainer = {
    borderRadius: "12px",
    border: "1px solid rgba(125,125,125,0.15)",
    overflow: "hidden",
    backgroundColor: "var(--body-color-less)",
  };

  const headCellSx = {
    fontSize: "0.72rem",
    fontWeight: 700,
    color: "var(--text-color)",
    opacity: 0.6,
    textTransform: "uppercase",
    letterSpacing: "0.06em",
    py: 1.5,
    px: 2,
    borderBottom: "1px solid rgba(125,125,125,0.15)",
    whiteSpace: "nowrap",
    backgroundColor: "var(--body-color-less2)",
  };

  const bodyCellSx = {
    py: 1.5,
    px: 2,
    fontSize: "0.85rem",
    color: "var(--text-color)",
    borderBottom: "1px solid rgba(125,125,125,0.08)",
  };

  const bodyRowSx = {
    "&:hover": { backgroundColor: "rgba(125,125,125,0.04)" },
    "& td": { border: "none", borderBottom: "1px solid rgba(125,125,125,0.08)" },
    "&:last-child td": { borderBottom: "none" },
  };

  const dialogPaper = {
    borderRadius: "16px",
    backgroundColor: "var(--popupbody-color)",
    color: "var(--text-color)",
  };

  const dialogTitleStyle = {
    fontWeight: 700,
    py: 2.25,
    color: "var(--text-color)",
    backgroundColor: "var(--popupheader-color)",
    position: "relative",
  };

  const editFieldStyle = {
    "& .MuiOutlinedInput-root": {
      backgroundColor: "var(--body-color-less)",
      borderRadius: "8px",
      "& fieldset": { borderColor: "rgba(125,125,125,0.2)" },
      "&:hover fieldset": { borderColor: "rgba(125,125,125,0.4)" },
      "&.Mui-focused fieldset": { borderColor: btncolor },
    },
    "& .MuiInputBase-input": { color: "var(--text-color)", fontSize: "0.88rem" },
    "& .MuiInputLabel-root": { display: "none" },
    "& .MuiSelect-icon": { color: "var(--text-color)" },
    "& .MuiFormHelperText-root": { color: "error.main" },
  };

  // ── Table columns ────────────────────────────────────────────────────────────

  const tableColumns = [
    "",
    "Ad No / Type / Asset",
    "Amount / Trade QTY / Limit",
    "Price / Floating / Rate",
    "Payment Method",
    "Last Updated / Created",
    "Status",
    "Actions",
  ];

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Box sx={pageWrapper}>
        {/* ── Hero Banner ── */}
        <Box
          sx={{
            ...heroBanner,
            background: `linear-gradient(135deg, ${alpha(
              btncolor || "#1976d2",
              0.95
            )} 0%, ${alpha(btncolor || "#1976d2", 0.75)} 100%)`,
          }}
        >
          <Box sx={heroIconBadge}>
            <ListAltIcon sx={{ color: "#fff", fontSize: 30 }} />
          </Box>
          <Box>
            <Typography sx={heroTitle}>My Ads</Typography>
            <Typography sx={heroSubtitle}>
              Manage your P2P buy and sell advertisements
            </Typography>
          </Box>
        </Box>

        {/* ── Main Card ── */}
        <Box sx={mainCard}>
          <P2PNavbar />

          <Box sx={{ p: { xs: 2, md: 3 } }}>
            {/* ── Filter Card ── */}
            <Box sx={filterCard}>
              <Box sx={filterGrid}>
                {/* Asset */}
                <Box sx={fieldWrap}>
                  <Typography sx={fieldLabel}>Asset</Typography>
                  <Select
                    value={coin}
                    onChange={(e) => setCoin(e.target.value)}
                    size="small"
                    displayEmpty
                    sx={modernFieldStyle}
                  >
                    <MenuItem value="">All Coins</MenuItem>
                    {allCurrencies.map((cur, index) => (
                      <MenuItem key={index} value={cur.currencyCode}>
                        {cur.currencyCode}
                      </MenuItem>
                    ))}
                  </Select>
                </Box>

                {/* Ad Type */}
                <Box sx={fieldWrap}>
                  <Typography sx={fieldLabel}>Ad Type</Typography>
                  <Select
                    value={adType}
                    onChange={(e) => setAdType(e.target.value)}
                    size="small"
                    displayEmpty
                    sx={modernFieldStyle}
                  >
                    <MenuItem value="">All Ad Types</MenuItem>
                    <MenuItem value="BUY">Buy</MenuItem>
                    <MenuItem value="SELL">Sell</MenuItem>
                  </Select>
                </Box>

                {/* Status */}
                <Box sx={fieldWrap}>
                  <Typography sx={fieldLabel}>Status</Typography>
                  <Select
                    value={statusSelected}
                    onChange={(e) => setStatusSelected(e.target.value)}
                    size="small"
                    displayEmpty
                    sx={modernFieldStyle}
                  >
                    <MenuItem value="2">All Status</MenuItem>
                    <MenuItem value="1">Published</MenuItem>
                    <MenuItem value="0">Offline</MenuItem>
                  </Select>
                </Box>

                {/* From Date */}
                <Box sx={fieldWrap}>
                  <Typography sx={fieldLabel}>From Date</Typography>
                  <DatePicker
                    value={fromDate}
                    onChange={(newValue) => setFromDate(newValue)}
                    slotProps={{
                      textField: {
                        size: "small",
                        fullWidth: true,
                        sx: modernFieldStyle,
                      },
                    }}
                  />
                </Box>

                {/* To Date */}
                <Box sx={fieldWrap}>
                  <Typography sx={fieldLabel}>To Date</Typography>
                  <DatePicker
                    value={toDate}
                    onChange={(newValue) => setToDate(newValue)}
                    slotProps={{
                      textField: {
                        size: "small",
                        fullWidth: true,
                        sx: modernFieldStyle,
                      },
                    }}
                  />
                </Box>

                {/* Actions */}
                <Box sx={{ display: "flex", gap: 1, alignItems: "flex-end" }}>
                  <Box onClick={getAllOpenAdsByUser} sx={filterBtn}>
                    <FilterListIcon sx={{ fontSize: 16 }} />
                    Filter
                  </Box>
                  <Box onClick={resetAll} sx={filterBtn}>
                    <RestartAltIcon sx={{ fontSize: 16 }} />
                    Reset
                  </Box>
                </Box>
              </Box>
            </Box>

            {/* ── Bulk Actions Bar ── */}
            <Box sx={bulkActionsBar}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={selectAllChecked}
                    onChange={(e) => handleSelectAll(e.target.checked)}
                    id="selectAll"
                    indeterminate={
                      selectedRows.length > 0 &&
                      selectedRows.length < adsDetailsList.length
                    }
                    sx={{
                      color: "rgba(125,125,125,0.5)",
                      "&.Mui-checked": { color: btncolor },
                      "&.MuiCheckbox-indeterminate": { color: btncolor },
                    }}
                  />
                }
                label={
                  <Typography sx={{ fontSize: "0.85rem", color: "var(--text-color)" }}>
                    Select All
                  </Typography>
                }
              />
              <Typography sx={{ fontSize: "0.85rem", color: "var(--text-color)", opacity: 0.7 }}>
                Selected: {selectedRows.length}
              </Typography>
              <ContainedButton
                variant="contained"
                disabled={selectedRows.length === 0}
                onClick={() => activateDeactivateAll(1)}
              >
                Activate All
              </ContainedButton>
              <ContainedButton
                variant="contained"
                disabled={selectedRows.length === 0}
                onClick={() => activateDeactivateAll(0)}
              >
                Take All Offline
              </ContainedButton>
            </Box>

            {/* ── Table ── */}
            <TableContainer sx={modernTableContainer}>
              <Table>
                <TableHead>
                  <TableRow>
                    {tableColumns.map((col, i) => (
                      <TableCell key={i} sx={headCellSx}>
                        {col}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {adsDetailsList.length === 0 ? (
                    <TableRow>
                      <TableCell colSpan={tableColumns.length} sx={{ border: "none", p: 0 }}>
                        <Box sx={{ py: 8, textAlign: "center" }}>
                          <InboxOutlinedIcon
                            sx={{
                              fontSize: 48,
                              color: "var(--text-color)",
                              opacity: 0.2,
                              mb: 1.5,
                              display: "block",
                              mx: "auto",
                            }}
                          />
                          <Typography
                            sx={{ fontSize: "0.9rem", color: "var(--text-color)", opacity: 0.5 }}
                          >
                            No ads found
                          </Typography>
                        </Box>
                      </TableCell>
                    </TableRow>
                  ) : (
                    adsDetailsList.map((ads, idx) => (
                      <TableRow key={ads.adId} sx={bodyRowSx}>
                        <TableCell sx={{ ...bodyCellSx, py: 1, px: 1 }}>
                          <Checkbox
                            checked={selectedRows.includes(ads.adId)}
                            onChange={() => handleSelectRow(idx)}
                            sx={{
                              color: "rgba(125,125,125,0.5)",
                              "&.Mui-checked": { color: btncolor },
                            }}
                          />
                        </TableCell>

                        <TableCell sx={bodyCellSx}>
                          <Typography sx={{ fontSize: "0.78rem", opacity: 0.6, mb: 0.25 }}>
                            {ads.adId}
                          </Typography>
                          <Typography
                            sx={{
                              fontSize: "0.82rem",
                              fontWeight: 600,
                              color: ads.adType === "BUY" ? "#2e7d32" : "#c62828",
                              mb: 0.25,
                            }}
                          >
                            {ads.adType}
                          </Typography>
                          <Typography sx={{ fontSize: "0.82rem", color: "var(--text-color)", opacity: 0.75 }}>
                            {ads.crypto}/{ads.fiat}
                          </Typography>
                        </TableCell>

                        <TableCell sx={bodyCellSx}>
                          <Typography sx={{ fontSize: "0.85rem", mb: 0.25 }}>{ads.amount}</Typography>
                          <Typography sx={{ fontSize: "0.82rem", opacity: 0.65, mb: 0.25 }}>
                            {ads.completedTradeQuantity}
                          </Typography>
                          <Typography sx={{ fontSize: "0.82rem", opacity: 0.65 }}>
                            {ads.minOrderLimit} - {ads.maxOrderLimit} {ads.fiat}
                          </Typography>
                        </TableCell>

                        <TableCell sx={bodyCellSx}>
                          <Typography sx={{ fontSize: "0.85rem", mb: 0.25 }}>{ads.price}</Typography>
                          {ads.priceType === "Floating" ? (
                            <Typography sx={{ fontSize: "0.82rem", opacity: 0.65, mb: 0.25 }}>
                              {ads.floatingPrice}
                            </Typography>
                          ) : (
                            <Typography sx={{ fontSize: "0.82rem", opacity: 0.4, mb: 0.25 }}>
                              ---
                            </Typography>
                          )}
                          <Typography sx={{ fontSize: "0.82rem", opacity: 0.65 }}>
                            {ads.exchangeRate}
                          </Typography>
                        </TableCell>

                        <TableCell sx={bodyCellSx}>
                          <Typography
                            sx={{
                              fontSize: "0.82rem",
                              color:
                                ads.paymentMethodNameDisplay === "No Payment Method Details Found"
                                  ? "#c62828"
                                  : btncolor,
                              fontWeight: 500,
                            }}
                          >
                            {ads.paymentMethodNameDisplay}
                          </Typography>
                        </TableCell>

                        <TableCell sx={bodyCellSx}>
                          <Typography sx={{ fontSize: "0.82rem", mb: 0.25 }}>{ads.lastUpdatedDate}</Typography>
                          <Typography sx={{ fontSize: "0.82rem", opacity: 0.65 }}>{ads.createDate}</Typography>
                        </TableCell>

                        <TableCell sx={bodyCellSx}>
                          <Typography
                            sx={{
                              fontSize: "0.82rem",
                              fontWeight: 600,
                              color: ads.status === "Offline" ? "#c62828" : btncolor,
                            }}
                          >
                            {ads.status}
                          </Typography>
                        </TableCell>

                        <TableCell sx={{ ...bodyCellSx, whiteSpace: "nowrap" }}>
                          <Box sx={{ display: "flex", alignItems: "center" }}>
                            {ads.status === "Offline" ? (
                              <Tooltip title="Make Ad published">
                                <Switch
                                  sx={{
                                    "& .MuiSwitch-switchBase.Mui-checked": { color: btncolor },
                                    "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
                                      backgroundColor: btncolor,
                                    },
                                  }}
                                  onChange={(e) => handleOnLineOfflineAds(e.target.checked, idx)}
                                />
                              </Tooltip>
                            ) : (
                              <Tooltip title="Make Ad offline">
                                <Switch
                                  defaultChecked
                                  sx={{
                                    "& .MuiSwitch-switchBase.Mui-checked": { color: btncolor },
                                    "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
                                      backgroundColor: btncolor,
                                    },
                                  }}
                                  onChange={(e) => handleOnLineOfflineAds(e.target.checked, idx)}
                                />
                              </Tooltip>
                            )}
                            <Tooltip title="Edit Ad">
                              <IconButton
                                sx={{ color: btncolor }}
                                onClick={() => tooltipOperations("edit", idx)}
                              >
                                <EditIcon fontSize="small" />
                              </IconButton>
                            </Tooltip>
                            <Tooltip title="Duplicate Ad with one click">
                              <IconButton
                                sx={{ color: btncolor }}
                                onClick={() => tooltipOperations("duplicate", idx)}
                              >
                                <ContentCopyIcon fontSize="small" />
                              </IconButton>
                            </Tooltip>
                            <Tooltip title="Delete Ad">
                              <IconButton
                                color="error"
                                onClick={() => tooltipOperations("delete", idx)}
                              >
                                <DeleteIcon fontSize="small" />
                              </IconButton>
                            </Tooltip>
                            <Tooltip title="Go to Order list">
                              <IconButton sx={{ color: btncolor }}>
                                <LinkIcon
                                  fontSize="small"
                                  onClick={() => handleRedirectOrderByAdsPage(ads)}
                                />
                              </IconButton>
                            </Tooltip>
                          </Box>
                        </TableCell>
                      </TableRow>
                    ))
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        </Box>

        {/* ── Delete Confirmation Dialog ── */}
        <Dialog
          open={deleteModalOpen}
          onClose={() => setDeleteModalOpen(false)}
          maxWidth="xs"
          fullWidth
          PaperProps={{ sx: dialogPaper }}
        >
          <DialogTitle sx={dialogTitleStyle}>
            Warning
            <IconButton
              aria-label="close"
              onClick={() => setDeleteModalOpen(false)}
              sx={{ position: "absolute", right: 8, top: 8, color: "var(--text-color)" }}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent sx={{ pt: 2.5, pb: 1 }}>
            <Typography sx={{ color: "var(--text-color)", fontSize: "0.92rem" }}>
              Do you want to delete the ad?
            </Typography>
          </DialogContent>
          <DialogActions sx={{ px: 3, pb: 2.5, gap: 1 }}>
            <OutlinedButton onClick={() => setDeleteModalOpen(false)} variant="outlined">
              Cancel
            </OutlinedButton>
            <OutlinedButton
              onClick={() => runApi("DELETE", "Ad deleted successfully", deleteIndex)}
              variant="outlined"
            >
              Delete
            </OutlinedButton>
          </DialogActions>
        </Dialog>

        {/* ── Edit Ad Dialog ── */}
        <Dialog
          open={editAdModalOpen}
          onClose={() => setEditAdModalOpen(false)}
          fullWidth
          maxWidth="lg"
          PaperProps={{ sx: dialogPaper }}
        >
          <DialogTitle sx={dialogTitleStyle}>
            Update Ad
            <IconButton
              onClick={() => setEditAdModalOpen(false)}
              sx={{ position: "absolute", right: 8, top: 8, color: "var(--text-color)" }}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent dividers sx={{ borderColor: "rgba(125,125,125,0.15)" }}>
            <form onSubmit={handleSubmit(handleUpdate)}>
              <Box
                sx={{
                  display: "grid",
                  gridTemplateColumns: { xs: "1fr 1fr", md: "repeat(6, 1fr)" },
                  gap: 2,
                }}
              >
                {/* Price Type */}
                <Box sx={fieldWrap}>
                  <Typography sx={fieldLabel}>Price Type</Typography>
                  <Select
                    {...register("priceType")}
                    defaultValue={watch("priceType") || "Fixed"}
                    size="small"
                    sx={editFieldStyle}
                  >
                    <MenuItem value="Fixed">Fixed</MenuItem>
                    <MenuItem value="Floating">Floating</MenuItem>
                  </Select>
                </Box>

                {/* Price */}
                <Box sx={fieldWrap}>
                  <Typography sx={fieldLabel}>Price</Typography>
                  <TextField
                    {...register("price", { required: "Price is required" })}
                    error={!!errors.price}
                    helperText={errors.price?.message}
                    size="small"
                    fullWidth
                    sx={editFieldStyle}
                  />
                </Box>

                {/* Amount */}
                <Box sx={fieldWrap}>
                  <Typography sx={fieldLabel}>Amount</Typography>
                  <TextField
                    {...register("amount", { required: "Amount is required" })}
                    error={!!errors.amount}
                    helperText={errors.amount?.message}
                    size="small"
                    fullWidth
                    sx={editFieldStyle}
                  />
                </Box>

                {/* Payment Time */}
                <Box sx={fieldWrap}>
                  <Typography sx={fieldLabel}>Payment Time</Typography>
                  <Select
                    {...register("paymentTimeLimit", {
                      setValueAs: (v) => Number(v),
                    })}
                    defaultValue={15}
                    size="small"
                    sx={editFieldStyle}
                  >
                    <MenuItem value={15}>15</MenuItem>
                    <MenuItem value={20}>20</MenuItem>
                    <MenuItem value={25}>25</MenuItem>
                  </Select>
                </Box>

                {/* Max Order Limit */}
                <Box sx={fieldWrap}>
                  <Typography sx={fieldLabel}>Max Order Limit</Typography>
                  <TextField
                    {...register("maxOrderLimit", {
                      required: "Max Order Limit is required",
                    })}
                    error={!!errors.maxOrderLimit}
                    helperText={errors.maxOrderLimit?.message}
                    size="small"
                    fullWidth
                    sx={editFieldStyle}
                  />
                </Box>

                {/* Min Order Limit */}
                <Box sx={fieldWrap}>
                  <Typography sx={fieldLabel}>Min Order Limit</Typography>
                  <TextField
                    {...register("minOrderLimit", {
                      required: "Min Order Limit is required",
                    })}
                    error={!!errors.minOrderLimit}
                    helperText={errors.minOrderLimit?.message}
                    size="small"
                    fullWidth
                    sx={editFieldStyle}
                  />
                </Box>

                {/* Remarks */}
                <Box sx={{ ...fieldWrap, gridColumn: { xs: "span 2", md: "span 3" } }}>
                  <Typography sx={fieldLabel}>Remarks (Optional)</Typography>
                  <TextField
                    {...register("remarks")}
                    size="small"
                    fullWidth
                    multiline
                    rows={2}
                    sx={editFieldStyle}
                  />
                </Box>

                {/* Auto Reply */}
                <Box sx={{ ...fieldWrap, gridColumn: { xs: "span 2", md: "span 3" } }}>
                  <Typography sx={fieldLabel}>Auto Reply (Optional)</Typography>
                  <TextField
                    {...register("autoReply")}
                    size="small"
                    fullWidth
                    multiline
                    rows={2}
                    sx={editFieldStyle}
                  />
                </Box>

                {/* Region */}
                <Box sx={{ ...fieldWrap, gridColumn: { xs: "span 2", md: "span 2" } }}>
                  <Typography sx={fieldLabel}>Region</Typography>
                  <Select
                    {...register("region")}
                    defaultValue={editAds[0]?.region || ""}
                    size="small"
                    sx={editFieldStyle}
                  >
                    {regionList.map((r) => (
                      <MenuItem key={r.countryName} value={r.countryName}>
                        {r.countryName}
                      </MenuItem>
                    ))}
                  </Select>
                </Box>

                {/* Registered Days */}
                <Box sx={{ ...fieldWrap, gridColumn: { xs: "span 1", md: "span 2" } }}>
                  <Typography sx={fieldLabel}>Registered Days</Typography>
                  <TextField
                    {...register("registeredDays", {
                      required: "Registered Days required",
                    })}
                    error={!!errors.registeredDays}
                    helperText={errors.registeredDays?.message}
                    size="small"
                    fullWidth
                    sx={editFieldStyle}
                  />
                </Box>

                {/* Total Holdings */}
                <Box sx={{ ...fieldWrap, gridColumn: { xs: "span 1", md: "span 2" } }}>
                  <Typography sx={fieldLabel}>Total Holdings</Typography>
                  <TextField
                    {...register("totalHoldings", {
                      required: "Total Holdings required",
                    })}
                    error={!!errors.totalHoldings}
                    helperText={errors.totalHoldings?.message}
                    size="small"
                    fullWidth
                    sx={editFieldStyle}
                  />
                </Box>
              </Box>

              <DialogActions sx={{ mt: 2, justifyContent: "center", px: 0 }}>
                <ContainedButton type="submit" variant="contained" disabled={!isDirty}>
                  Submit
                </ContainedButton>
              </DialogActions>
            </form>
          </DialogContent>
        </Dialog>
      </Box>
    </LocalizationProvider>
  );
}
